import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-get-started-today',
  templateUrl: './get-started-today.component.html',
  styleUrls: ['./get-started-today.component.css'],
  imports: [RouterModule]
})
export class GetStartedTodayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
